export const ATHENA = {
  // Navigation
  navLogo: "nav-logo",
  navAbout: "nav-link-about",
  navDomains: "nav-link-domains",
  navScience: "nav-link-science",
  navContact: "nav-link-contact",
  navCtaButton: "nav-cta-contact-button",
  navMobileToggle: "nav-mobile-toggle",

  // Hero
  heroSection: "hero-section",
  heroHeadline: "hero-headline",
  heroSubheadline: "hero-subheadline",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",

  // About
  aboutSection: "about-section",
  missionStatement: "mission-statement",

  // Domains
  domainsSection: "domains-section",
  domainNutra: "domain-card-nutraceuticals",
  domainBiotech: "domain-card-biotechnology",
  domainLifeSciences: "domain-card-life-sciences",

  // Products / Solutions
  productsSection: "products-section",
  productItem: (slug) => `product-item-${slug}`,

  // R&D / Science
  scienceSection: "science-section",
  scienceCta: "science-learn-more",

  // Why choose us
  whySection: "why-section",
  metricItem: (slug) => `metric-${slug}`,

  // Team
  teamSection: "team-section",
  teamMember: (slug) => `team-member-${slug}`,

  // Contact
  contactSection: "contact-section",
  contactForm: "contact-form",
  contactName: "contact-input-name",
  contactEmail: "contact-input-email",
  contactCompany: "contact-input-company",
  contactSubject: "contact-input-subject",
  contactMessage: "contact-input-message",
  contactSubmit: "contact-submit-button",
  contactSuccess: "contact-success-message",
  contactError: "contact-error-message",

  // Footer
  footer: "site-footer",
  footerCopyright: "footer-copyright",
};
